import { Document, Page } from "react-pdf";
import { useState } from "react";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import PDFDATA from "@/assets/data/Cancer Care - May 2026.pdf";
import "./PDFViewer.css";

function PDFViewer() {
    const [pageNumber, setPageNumber] = useState(1);
    const [numPages, setNumPages] = useState<any>(null);

    function onDocumentLoaded({ numPages }: { numPages: any }) {
        setNumPages(numPages);
        setPageNumber(1);

    }
    function nextPage() {
        setPageNumber((prev) => (prev < numPages ? prev + 1 : prev))
    }
    function prevPage() {
        setPageNumber((prev) => (prev > 1 ? prev - 1 : prev))
    }
    return (
        <div>

        <div className="pdf-viewer">
            <Document file={PDFDATA} onLoadSuccess={onDocumentLoaded}>
                <Page pageNumber={pageNumber}
                renderAnnotationLayer={false}
                renderTextLayer={false}
                // scale={1.5} 
                // rotate={90} 
                // width={200} 
                // height={200} 
                />
            </Document>
            
        </div>
        <div className="pdf-controls">
                <button onClick={prevPage} disabled={pageNumber <= 1}>
                    ◀ Prev
                </button>
                <span>
                    Page {pageNumber} of {numPages}
                </span>
                <button onClick={nextPage} disabled={pageNumber >= numPages}>
                    Next ▶
                </button>
            </div>
        </div>
    )
}
export default PDFViewer;